export default __webpack_public_path__ + "static/media/pb.c1209732.svg";